export interface IncomePaymentWhTaxItem {
  subTotal?: number | string | null
}

/**
 * Calculate withholding tax for an income payment.
 *
 * Most income documents provide line items, so their existing per-item
 * calculation remains unchanged. Billing notes do not have their own income
 * items; in that case the outstanding payment amount is the tax base.
 * The value 99 means "custom" and must still be entered manually.
 */
export const incomePaymentWhTaxPrice = (
  totalAmount: number,
  items: IncomePaymentWhTaxItem[] = [],
  whTaxPercent: number = 0
) => {
  if (!items.length) {
    return whTaxPercent === 99 ? 0 : totalAmount * (whTaxPercent / 100)
  }

  const whTax = whTaxPercent / 100

  return items.reduce((sum, item) => {
    if (whTaxPercent !== 99) {
      return sum + (item?.subTotal ? Number(item.subTotal) * whTax : totalAmount * whTax)
    }

    return sum + totalAmount * whTax
  }, 0)
}
